/**
 * 배달앱 연동 모달 
 */
import { inject, observer } from "mobx-react";

import { fn_connectDlvAppInit } from "function/FnBodyDelivery";
import { Modal } from "components/modal/compound/Modal";
import { Button } from "components/ui/Button";
import confirmImg from "static-file/images/confirm_img.png";
import connectImg from "static-file/images/yogiyoConnect.png";
import disConnectImg from "static-file/images/yogiyoDisConnect.png";
import failImg from "static-file/images/yogiyoFail.png";
const RemoteSupportContent = ({ rootStore }: { rootStore: any }) => {
  const layerStore = rootStore.layerStore;
  return (
    <>
      <img src={confirmImg} alt="confirm_img" className="mb-8" />
      <p className="text-[18px] font-bold">
        전달해주신 시간에 맞춰
        <br />
        1544-3583으로 전화 드리겠습니다
      </p>
      <p className="text-gray-600 text-[15px] font-normal">
        {layerStore.getMappingAction ? "설치" : "해제"} 시 {layerStore.title()} 로그인 계정을 미리 준비해주세요
      </p>
    </>
  );
};

/** 매장 연동, 연동 해제 성공 */
const ConnectionSuccessContent = ({ rootStore }: { rootStore: any }) => {
  const { layerStore } = rootStore;
  return (
    <>
      <img src={layerStore.getMappingAction ? connectImg : disConnectImg} alt="connect_img" className="mb-8" />
      <p className="text-[18px] font-bold">
        {layerStore.getYgyShopItem.vendorNm}
        <br />
        매장 연동이 {layerStore.getMappingAction ? "완료" : "해제"}되었어요!
      </p>
      {layerStore.getMappingAction && (
        <p className="text-gray-600 text-[15px] font-normal">이제 배달매니저에서 바로 주문 접수하세요</p>
      )}
    </>
  );
};

/** 매장 연동, 연동 해제 실패 */
const ConnectionFailContent = ({ rootStore }: { rootStore: any }) => {
  const { layerStore } = rootStore;

  return (
    <>
      <img src={failImg} alt="fail_img" className="mb-8" />
      <p className="text-[18px] font-bold">
        {layerStore.getMappingAction ? "매장 연동" : "연동 해제"}에 실패했어요
        <br />
        재시도 후 실패시, 고객센터에 문의해주세요
      </p>
      <p className="text-gray-600 text-[15px] font-normal">1544-3583 (영업일 09:30~18:00)</p>
    </>
  );
};

/** 매장 조회 실패 */
const ShopLookupFailContent = ({ contactNumber }: { contactNumber: string }) => {
  return (
    <>
      <img src={failImg} alt="fail_img" className="mb-8" />
      <p className="text-[18px] font-bold">
        매장 조회에 실패했어요
        <br />
        상점 상태를 고객센터에 문의해주세요
      </p>
      <p className="text-gray-600 text-[15px] font-normal">{contactNumber}</p>
    </>
  );
};

const CONTENT_MAP = {
  BMN: RemoteSupportContent,
  NBG: RemoteSupportContent,
  JNJ: RemoteSupportContent,
  HPD: RemoteSupportContent,
  WMP: RemoteSupportContent,
  MKB: RemoteSupportContent,
  YGY: ConnectionSuccessContent,
  DDY: ConnectionSuccessContent,
  OTA: ConnectionSuccessContent,
  YGY_FAIL: ConnectionFailContent,
  DDY_FAIL: ConnectionFailContent,
  OTA_FAIL: ConnectionFailContent,
  YGY_ERR: (_: { rootStore: any }) => <ShopLookupFailContent contactNumber="요기요 고객센터 1661-5270" />,
  DDY_ERR: (_: { rootStore: any }) => <ShopLookupFailContent contactNumber="땡겨요 고객센터 1661-5489" />,
  OTA_ERR: (_: { rootStore: any }) => <ShopLookupFailContent contactNumber="올때아아 고객센터 1577-3059" />,
};

type ContentMapKey = keyof typeof CONTENT_MAP;

const DeliveryConnectComplete = ({ rootStore }: { rootStore: any }) => {
  const layerStore = rootStore.layerStore;
  const title = layerStore.title();
  const ContentComponent = CONTENT_MAP[layerStore.tp as ContentMapKey];

  if (!layerStore.getLayerCompleteView) return null;

  return (
    <Modal.BackGround containerWidth="374px" border={true}>
      <Modal.Header
        title={`${title} 연동`}
        onClose={() => {
          layerStore.setLayerCompleteView(false);
          fn_connectDlvAppInit(rootStore);
        }}
      />
      <Modal.Content>
        <div className="flex flex-col items-center gap-2 text-center justify-center min-h-[332px]">
          <ContentComponent rootStore={rootStore} />
        </div>
      </Modal.Content>
      <Modal.Divider className="!mt-2" />
      <Modal.Bottom>
        <Button
          variant="default"
          size="sm"
          onClick={() => {
            layerStore.setLayerCompleteView(false);
            fn_connectDlvAppInit(rootStore);
          }}
          className="!font-bold"
        >
          확인
        </Button>
      </Modal.Bottom>
    </Modal.BackGround>
  );
};

export default inject("rootStore")(observer(DeliveryConnectComplete));
